// datoteka: src/Components/UserDashboard/MobileAdCard.js

import React from 'react';
import { Card, CardContent, CardMedia, Typography, Box, IconButton, Chip, Stack } from '@mui/material';
import { Gavel, Edit, Delete, PhotoCamera } from '@mui/icons-material';

const MobileAdCard = ({ item, onAppeal, onEdit, onDelete, getImageUrl, getStatusClass, navigateToAd, isSelected, onSelectToggle }) => {
    const primaryImage = item.images?.find(img => img.is_primary) || item.images?.[0];
    const imageUrl = getImageUrl(primaryImage?.image_url, 'card', { text: "Oglas" });

    let displayStatusText = item.status;
    if (item.moderation_status === 'zavrnjen') displayStatusText = 'zavrnjen';
    if (item.moderation_status === 'v_pregledu') displayStatusText = 'v pregledu';

    return (
        <Card onClick={onSelectToggle} sx={{ display: 'flex', mb: 2, width: '100%', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', border: isSelected ? '2px solid #463CE5' : 'none', }}>

            <Box
                onClick={navigateToAd}
                sx={{
                    width: 100,
                    height: 100,
                    flexShrink: 0,
                    m: 1,
                    borderRadius: 1.5,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    backgroundColor: '#f0f0f0'
                }}
            >
                {primaryImage ? (
                    <CardMedia component="img" sx={{ width: '100%', height: '100%', objectFit: 'cover' }} image={imageUrl} alt={item.title} />
                ) : (
                    <PhotoCamera sx={{ color: '#ccc', fontSize: '2.5rem' }} />
                )}
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'hidden', p: 1 }}>
                <CardContent sx={{ flex: '1 0 auto', p: '8px !important' }}>

                    <Typography
                        component="div"
                        variant="h6"
                        onClick={navigateToAd}
                        sx={{
                            cursor: 'pointer',
                            fontSize: '1rem',
                            fontWeight: 'bold',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            mb: 0.5,
                        }}>
                        {item.title}
                    </Typography>

                    <Typography variant="subtitle1" color="text.secondary" component="div" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                        {item.price} €
                    </Typography>

                    {/* --- SPREMEMBA: Kategorija je zdaj tukaj --- */}
                    {item.category?.name && (
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                            Kategorija: {item.category.name}
                        </Typography>
                    )}

                    <Stack direction="row" spacing={1} alignItems="center">
                        <Chip
                            label={displayStatusText}
                            size="small"
                            sx={{
                                backgroundColor: getStatusClass(item.status, item.moderation_status),
                                color: '#fff',
                                fontWeight: 'bold',
                                height: '24px'
                            }}
                        />
                    </Stack>
                </CardContent>

                <Stack direction="row" spacing={0} sx={{ mt: 'auto', alignSelf: 'flex-start' }}>
                    {item.moderation_status === 'zavrnjen' && (
                        <IconButton onClick={(e) => { e.stopPropagation(); onAppeal(); }} size="small" aria-label="pritožba" title="Pritožba na zavrnitev">
                            <Gavel sx={{ color: "#145bb8ff", fontSize: '1.25rem' }} />
                        </IconButton>
                    )}
                    <IconButton onClick={(e) => { e.stopPropagation(); onEdit(); }} size="small" aria-label="uredi" title="Uredi">
                        <Edit sx={{ color: "#14B8A6", fontSize: '1.25rem' }} />
                    </IconButton>
                    <IconButton onClick={(e) => { e.stopPropagation(); onDelete(); }} size="small" aria-label="izbriši" title="Izbriši/Prodano">
                        <Delete sx={{ color: "red", fontSize: '1.25rem' }} />
                    </IconButton>
                </Stack>
            </Box>
        </Card>
    );
};

export default MobileAdCard;